import { ValidationRule } from 'types';

import { translate } from './translate';

export default class validation {
    constructor(rules: ValidationRule[] = []) {
        //@ts-ignore
        this.rules = rules; // Set default value to an empty array
    }

    static regexPatterns = {
        latitudeDMS: /^[0-9]{2}\s[0-9]{2}\s(?:\b[0-9]+(?:\.[0-9]*)?|\.[0-9]+\b)\s[N|S]$/i,
        longitudeDMS: /^[0-9]{2}\s[0-9]{2}\s(?:\b[0-9]+(?:\.[0-9]*)?|\.[0-9]+\b)\s[E|W]$/i,
        latitudeDD: /^(\+|-)?(?:90(?:(?:\.0{1,16})?)|(?:[0-9]|[1-8][0-9])(?:(?:\.[0-9]{1,16})?))$/,
        longitudeDD: /^(\+|-)?(?:180(?:(?:\.0{1,16})?)|(?:[0-9]|[1-9][0-9]|1[0-7][0-9])(?:(?:\.[0-9]{1,16})?))$/,
        float: /^[+-]?((\.\d+)|(\d+(\.\d+)?))$/,
        integer: /^-?\d+$/,
    };

    check(inputs) {
        if (!inputs || typeof inputs !== 'object') {
            throw new Error('Inputs must be a valid object.');
        }

        const errors = {};
        //@ts-ignore
        this.rules.forEach((rule) => {
            const { name, rules: fieldRules } = rule;

            fieldRules.forEach((validationRule) => {
                const value = inputs[name];

                // Parse rule arguments (e.g., min:10 or between:1,10)

                // eslint-disable-next-line prefer-const
                let [ruleType, ...args] = validationRule.split(':');
                args = args.length > 0 ? args[0].split(',') : [];

                // Perform validation based on rule type
                switch (ruleType) {
                    case 'required':
                        if (!value || value === '') {
                            errors[name] = errors[name] || translate('This field is required.');
                        }
                        break;

                    case 'multiRequired':
                        if (!Array.isArray(value) || value.length === 0) {
                            errors[name] = errors[name] || translate('This field is required.');
                        }
                        break;

                    case 'latitudeDMS':
                        if (!validation.regexPatterns.latitudeDMS.test(value)) {
                            errors[name] = errors[name] || translate('Invalid latitude in DMS format.');
                        }
                        break;

                    case 'longitudeDMS':
                        if (!validation.regexPatterns.longitudeDMS.test(value)) {
                            errors[name] = errors[name] || translate('Invalid longitude in DMS format.');
                        }
                        break;

                    case 'latitudeDD':
                        if (!validation.regexPatterns.latitudeDD.test(value)) {
                            errors[name] = errors[name] || translate('Invalid latitude in decimal degrees.');
                        }
                        break;

                    case 'longitudeDD':
                        if (!validation.regexPatterns.longitudeDD.test(value)) {
                            errors[name] = errors[name] || translate('Invalid longitude in decimal degrees.');
                        }
                        break;

                    case 'float':
                        if (!validation.regexPatterns.float.test(value)) {
                            errors[name] = errors[name] || translate('Invalid float value.');
                        }
                        break;

                    case 'integer':
                        if (!validation.regexPatterns.integer.test(value)) {
                            errors[name] = errors[name] || translate('Invalid integer value.');
                        }
                        break;

                    case 'min':
                        if (parseFloat(value) < parseFloat(args[0])) {
                            errors[name] = errors[name] || `${translate('Value must be at least')} ${args[0]}.`;
                        }
                        break;

                    case 'max':
                        if (parseFloat(value) > parseFloat(args[0])) {
                            errors[name] = errors[name] || `${translate('Value must not exceed')} ${args[0]}.`;
                        }
                        break;

                    case 'between':
                        if (parseFloat(value) < parseFloat(args[0]) || parseFloat(value) > parseFloat(args[1])) {
                            errors[name] =
                                errors[name] || `${translate('Value must be between')} ${args[0]} and ${args[1]}.`;
                        }
                        break;

                    case 'isString':
                        if (typeof value !== 'string') {
                            errors[name] = errors[name] || translate('Value must be a string.');
                        }
                        break;

                    case 'isInteger':
                        if (!Number.isInteger(parseFloat(value))) {
                            errors[name] = errors[name] || translate('Value must be an integer.');
                        }
                        break;

                    case 'isFloat':
                        if (isNaN(parseFloat(value)) || !validation.regexPatterns.float.test(value)) {
                            errors[name] = errors[name] || translate('Value must be a float.');
                        }
                        break;

                    default:
                        console.warn(`Unknown validation rule: ${ruleType}`);
                        break;
                }
            });
        });

        return {
            errors,
            status: Object.keys(errors).length > 0, // Returns true if errors exist
        };
    }
}
